import React from "react";
import { useLayoutEffect } from "react";
import { useState } from "react";
import { image } from "./image.module.scss";

const Image = ({
  gatsbyImage,
  alt,
  loading,
  className,
  sizes: sizesOverride,
  onLoad,
}) => {
  const eager = loading === "eager";
  const [opacity, setOpacity] = useState(eager ? 1 : 0);
  const imageData =
    gatsbyImage?.localFile?.childImageSharp?.gatsbyImageData?.images;
  const webpSource = imageData?.sources[0];
  const fallback = imageData?.fallback;
  const sizesAttr = sizesOverride ?? webpSource?.sizes ?? fallback?.sizes;

  useLayoutEffect(() => {
    if (!eager) {
      setOpacity(1);
    }
  }, [eager]);

  return (
    <picture className={`${className} ${image}`}>
      <source
        type={webpSource?.type}
        srcSet={webpSource?.srcSet}
        sizes={sizesAttr}
      ></source>
      <img
        decoding="async"
        loading={loading ?? "lazy"}
        style={{ opacity }}
        srcSet={fallback?.srcSet}
        sizes={sizesAttr}
        alt={alt ?? gatsbyImage?.alternativeText ?? "Image"}
        src={fallback?.src || gatsbyImage?.url}
        onLoad={onLoad}
      ></img>
    </picture>
  );
};

export default Image;
